module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Roman.aaa09d28.ttf";